import { render, staticRenderFns } from "./CloudMarket.vue?vue&type=template&id=156ce3ae&"
import script from "./CloudMarket.vue?vue&type=script&lang=js&"
export * from "./CloudMarket.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports